import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'seo-explore_page_cta-click';
/**
 * click Shop All button on explore page
 */
export function trackSeoExplorePageCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
